"use client";

import { Card } from "react-bootstrap";
import { Product } from "../../../../store/cart-store";

const Description = ({ product }: { product: Product }) => {
  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4 rounded-top-0">
        <Card.Body className="p-4">
          {product.longDescription}
        </Card.Body>
      </Card>
    </>
  );
};

export default Description;
